package horcrux.common.api.dtos.types

import horcrux.common.api.dtos.RawDocument
import kotlinx.serialization.Serializable

@Serializable
sealed interface DocumentIdentifier {
    val documentURL: DocumentURL
    val documentName: DocumentName
    val documentRelationship: DocumentRelationship
    fun getDefaultCollectionName(collectionNames: Set<CollectionName>): CollectionName
}

@Serializable
data class UploadedDocumentIdentifier(
    val rawDocumentID: RawDocumentID,
    override val documentURL: DocumentURL,
    override val documentName: DocumentName
) : DocumentIdentifier {
    constructor(rawDocumentID: RawDocumentID, documentName: DocumentName) : this(
        rawDocumentID,
        rawDocumentID.authenticatedURL,
        documentName
    )

    override val documentRelationship: DocumentRelationship
        get() = RootDocumentRelationship

    override fun getDefaultCollectionName(collectionNames: Set<CollectionName>): CollectionName =
        CollectionName.getUniqueCollectionNameFromValue(documentName.value, collectionNames)
}

@Serializable
data class DocumentIdentifierWithRawDocument(
    override val documentURL: DocumentURL,
    override val documentName: DocumentName,
    override val documentRelationship: DocumentRelationship,
    val rawDocument: RawDocument,
) : DocumentIdentifier {
    constructor(
        rawDocument: RawDocument,
        associatedDocumentID: DocumentID,
        documentIdentifier: DocumentIdentifier
    ) : this(
        documentURL = documentIdentifier.documentURL,
        documentName = documentIdentifier.documentName,
        documentRelationship = AssociateDocumentRelationship(associatedDocumentID),
        rawDocument = RawDocument(
            byteArray = rawDocument.byteArray,
            documentType = DocumentType.JSON,
        )
    )

    val rawDocumentName: RawDocumentName
        get() = RawDocumentName(documentURL.value)

    override fun getDefaultCollectionName(collectionNames: Set<CollectionName>): CollectionName =
        CollectionName.getUniqueCollectionNameFromValue(documentURL.value, collectionNames)
}
